import type { WebObservability } from "@infinitaslearning/observability-web";
import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  apm: WebObservability | null;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class GlobalErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    const apm = this.props.apm;

    apm?.captureError(error, "app-error-boundary", {
      component_stack: `${errorInfo.componentStack}`,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: "20px", textAlign: "center" }}>
            <h1>Something went wrong</h1>
            <p>We've been notified and are working on it.</p>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
